import { Divider, Menu, MenuItem } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey } from "assets/jss/common-styles";
import ButtonEllipsis from "components/Buttons/ButtonEllipsis";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import { FeedItemDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import PublicationLogDialog from "views/Publication/Dialogs/PublicationLogDialog";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    menuAnchorEl: HTMLElement;
    dialog: any;
}

interface IProps {
    data: FeedItemDto;
    onEditPublication: () => void;
    onRemovePublication: () => void;
    onUpdateCard: (data: DeepPartial<FeedItemDto>) => void;
    onInfoRequest?: () => void;
}

type Props = IProps & StyledComponentProps<FeedClassKey> & WithSnackbar & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class ActionsPollDropDown extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            menuAnchorEl: null,
            dialog: null
        };
    }

    ///
    private buildDropDownMenu(): Array<any> {

        const {
            t,
            data: {
                permissions
            },
            onEditPublication,
            onInfoRequest,
            onRemovePublication
        } = this.props;

        const actionMenu: Array<any> = [];

        if (onEditPublication)
            actionMenu.push(<MenuItem key="edit" onClick={() => this.handleEdit()}>{t("Common.MenuAction.Edit")}</MenuItem>);

        if (onInfoRequest)
            actionMenu.push(<MenuItem key="info" onClick={() => this.handleInfoRequest()}>{t("Common.MenuAction.Info")}</MenuItem>);

        if (permissions.canEdit) {
            if (actionMenu.length > 0) actionMenu.push(<Divider key="dividerPermission" />);
            actionMenu.push(<MenuItem key="audit" onClick={this.handleAudit}>{t("Common.MenuAction.Audit")}</MenuItem>);
        }

        if (onRemovePublication) {
            if (actionMenu.length > 0) actionMenu.push(<Divider key="dividerDelete" />);
            actionMenu.push(<MenuItem key="delete" onClick={() => this.handleDelete()}><MuiColor variant="error">{t("Common.MenuAction.Delete")}</MuiColor></MenuItem>);
        }

        //
        return actionMenu;
    }

    ///
    private handleCloseDialog(): void {
        this.setState({ dialog: null });
    }

    ///
    private handleOpenMenu(e: React.MouseEvent<HTMLElement>) {
        this.setState({ menuAnchorEl: e.currentTarget });
    }

    ///
    private handleAudit = () => {
        this.setState({
            menuAnchorEl: null,
            dialog: <PublicationLogDialog
                publicationId={this.props.data.publicationId}
                onClose={() => this.handleCloseDialog()}
            />
        });
    };

    ///
    private handleEdit() {
        this.setState({ menuAnchorEl: null }, () =>
            this.props.onEditPublication()
        );
    }

    ///
    private handleDelete() {
        this.setState({ menuAnchorEl: null }, () =>
            this.props.onRemovePublication()
        );
    }

    ///
    private handleInfoRequest() {
        this.setState({ menuAnchorEl: null }, () =>
            this.props.onInfoRequest()
        );
    }

    ///
    private handleCloseMenu() {
        this.setState({ menuAnchorEl: null });
    }

    ///
    public render() {

        const { menuAnchorEl, dialog } = this.state;
        const actionMenu = this.buildDropDownMenu();

        return actionMenu.length == 0
            ? null
            : (
                <>
                    {dialog}

                    <ButtonEllipsis
                        onClick={(e) => { this.handleOpenMenu(e); }}
                    />
                    <Menu
                        anchorEl={menuAnchorEl}
                        open={menuAnchorEl != null}
                        onClose={() => { this.handleCloseMenu(); }}
                    >
                        {actionMenu}
                    </Menu>
                </>
            );
    }
}

export default withSnackbar(withTranslation()(ActionsPollDropDown));
